import { RequestHelper,IResponse,IResponseWithData } from "../libs/request-helper";
import {Utils} from "../utils";
import {MagazineReuestDto} from "../dtos/magazine-home-request-dto";
import { MagazineHomeResponseDto } from "../dtos/magazine-home-response-dto";
import {MagazineEntryDto} from "../dtos/magazine-entry-dto";
import {ItemRender} from "../renderer/magazine/item-renderer"
import {ErrorRenderer} from "../renderer/error-renderer";
import {BookRenderer} from "../renderer/home/book-renderer";
import {NewsletterRenderer} from "../renderer/home/newsletter-renderer";
import {ScheduleRenderer} from "../renderer/home/schedule-renderer";
import {HomeItemRenderer} from "../renderer/home/home-item-renderer";
import {VideoRenderer} from "../renderer/home/video-renderer";
import {ImageOverlayHelper} from "../libs/image-overlay-helper";
import { RecommenderRequestDto } from '../dtos/recommender-request-dto';
import { RecommenderResponseDto } from '../dtos/recommender-response-dto';
import { RecommenderDto } from '../dtos/recommender-dto';
import { FacebookRenderer } from '../renderer/home/facebook-renderer';

declare var Hyphenator:any;
declare var THOR:any;

export class Home{
	protected static requestUrl = "/wp-content/themes/enfold-schauspielhaus/json/magazine.php";
	protected static ERROR_MSG = "Es konnten leider keine Magazineinträge gefunden werden!";

	protected static requestUrlRec = "/wp-content/themes/enfold-schauspielhaus/json/recommender.php";

	protected static dataContainer: HTMLElement;
	protected static bannerContainer: HTMLElement;
	protected static itemRenderer: ItemRender;
	protected static isLoading: boolean = false;
	protected static requestDto: MagazineReuestDto;
	protected static errorRenderer: ErrorRenderer;
	protected static columns:HTMLElement[];

	protected static recommenderId?: string | undefined;
	protected static recommentaionsRequestDto: RecommenderRequestDto
	private static recommendations: RecommenderDto[]


	public static async init():Promise<void> {
		Home.recommentaionsRequestDto = {};

		Home.dataContainer = <HTMLElement>document.getElementById("p_homeData");
		Home.bannerContainer = <HTMLElement>document.getElementById("p_homeBanner").getElementsByClassName('_homeBanner')[0]
		Home.errorRenderer = new ErrorRenderer(Home.dataContainer,Home.ERROR_MSG);
		document.addEventListener('DOMContentLoaded', Home.onDocumentLoaded, false);
	}

	protected static onDocumentLoaded() {
		Home.requestDto = new MagazineReuestDto();
		Home.requestDto.isHome = true;
		Home.loadData();
	}



	protected static renderHero(hero: MagazineEntryDto){
		var heroWrapper = document.createElement("div");
		heroWrapper.classList.add("sshgWidget_heroTeaser");
		Home.dataContainer.appendChild(heroWrapper);
		var heroRenderer= new ItemRender(heroWrapper,true);
		heroRenderer.render(hero);
	}

	protected static appendData(data: MagazineEntryDto[]){
		if(data.length > 0){
			Home.columns =  new Array<HTMLElement>(2);
			Home.columns[0] = document.createElement("div");
			Home.columns[0].classList.add("_leftContainer");
			Home.columns[1] = document.createElement("div");
			Home.columns[1].classList.add("_rightContainer");
			Home.dataContainer.appendChild(Home.columns[0]);

			var tabletNav = document.createElement("div");
			tabletNav.classList.add("_tabletHomeNav");
			var tabletNavList = document.createElement("ul");

			var listItemPlaylist = document.createElement("li");
			var listItemPlaylistLink = document.createElement("a");
			listItemPlaylistLink.innerHTML = "SPIELPLAN";
			listItemPlaylistLink.href = "/spielplan/#Alle";
			listItemPlaylist.appendChild(listItemPlaylistLink);

			var listItemEnsemble = document.createElement("li");
			var listItemEnsembleLink = document.createElement("a");
			listItemEnsembleLink.innerHTML = "ENSEMBLE";
			listItemEnsembleLink.href = "/ensemble";
			listItemEnsemble.appendChild(listItemEnsembleLink);

			var listItemActiv = document.createElement("li");
			var listItemActivLink = document.createElement("a");
			listItemActivLink.innerHTML = "MITMACHEN";
			listItemActivLink.href = "/schauspiel-aktiv";
			listItemActiv.appendChild(listItemActivLink);

			var listItemDramaHome = document.createElement("li");
			var listItemDramaHomeLink = document.createElement("a");
			listItemDramaHomeLink.innerHTML = "WIR*";
			listItemDramaHomeLink.href = "/wir";
			listItemDramaHome.appendChild(listItemDramaHomeLink);

			var listItemNewSeason = document.createElement("li");
			listItemNewSeason.classList.add("bg-lila");
			var listItemNewSeasonLink = document.createElement("a");
			listItemNewSeasonLink.innerHTML = "SPIELZEIT 2023/24";
			listItemNewSeasonLink.href = "https://schauspielhaus-graz-neu.buehnen-graz.com/";
			listItemNewSeasonLink.target = "_blank";
			listItemNewSeason.appendChild(listItemNewSeasonLink);

			var listItemDasGrueneTheater = document.createElement("li");
			listItemDasGrueneTheater.classList.add("bg-green");
			var listItemDasGrueneTheaterLink = document.createElement("a");
			listItemDasGrueneTheaterLink.innerHTML = "DAS GRÜNE THEATER";
			listItemDasGrueneTheaterLink.href = "https://shg.dasgruenetheater.com/";
			listItemDasGrueneTheaterLink.target = "_blank";
			listItemDasGrueneTheater.appendChild(listItemDasGrueneTheaterLink);

			var listItemTicket = document.createElement("li");
			var listItemTicketLink = document.createElement("a");
			listItemTicketLink.innerHTML = "KARTEN & ABOS";
			listItemTicketLink.href = "/karten-und-abos/abos-und-10er-block";
			listItemTicket.appendChild(listItemTicketLink);

			tabletNavList.appendChild(listItemPlaylist);
			tabletNavList.appendChild(listItemEnsemble);
			tabletNavList.appendChild(listItemActiv);
			tabletNavList.appendChild(listItemNewSeason);
			tabletNavList.appendChild(listItemDramaHome);
			tabletNavList.appendChild(listItemDasGrueneTheater);
			tabletNavList.appendChild(listItemTicket);
			tabletNav.appendChild(tabletNavList);

			Home.columns[0].appendChild(tabletNav);

			Home.dataContainer.appendChild(Home.columns[1]);

			Home.itemRenderer = new ItemRender(Home.columns[0]);
			if(Home.recommendations && Home.recommendations.length>=3){
				Home.appendRecommendations();
			}

			for(var i = 0; i < data.length; i++){
					Home.itemRenderer.render(data[i]);
			}
		}
		Hyphenator.run();
	}

	private static appendRecommendations(){

		for(var i = 0; i < Home.recommendations.length; i++){
			Home.itemRenderer.renderRecommendation(Home.recommendations[i], Home.recommenderId);
		}
	}

	protected static async loadData(){
		if(!Home.isLoading){
			Home.isLoading = true;

			// fake recommendations
			// const testRec = ['172535432', '172811752', '173166209']
			// Home.recommenderId = 'dkagfbhkaf-hgkdshjg-5667567'
			// Home.recommentaionsRequestDto.recommendations = testRec
			// var responseJson = await RequestHelper.postJsonAndSpin<RecommenderResponseDto>(Home.requestUrlRec, Home.recommentaionsRequestDto);
			// console.log(responseJson)
			// var dataRec = <RecommenderResponseDto>responseJson.data;
			// Home.recommendations = dataRec.recommendations;

			// real recommendations
			var responseRec = await THOR.Main.getRecommendations("homepage", 3, "30")
			if(responseRec){
				Home.recommenderId = responseRec.recoId;
				Home.recommentaionsRequestDto.recommendations = responseRec.results;
				var responseJson = await RequestHelper.postJsonAndSpin<RecommenderResponseDto>(Home.requestUrlRec, Home.recommentaionsRequestDto);
				var dataRec = <RecommenderResponseDto>responseJson.data;
				Home.recommendations = dataRec.recommendations;
			}

			var response = await RequestHelper.postJsonAndSpin(Home.requestUrl, Home.requestDto);
			Home.processResponse(response);
			Home.isLoading = false;
		}
	}

	protected static processResponse(res: IResponse){
		if(!res.requestError){
			var response = <IResponseWithData<MagazineHomeResponseDto>>res;
			var responseDto = <MagazineHomeResponseDto>response.data;
			if(responseDto.hero != null){
				Home.renderHero(responseDto.hero);
			}
			if(responseDto.entries.length > 0){
				var data = responseDto.entries;
				Home.appendData(data);
			}
			Home.renderWidgets(responseDto,true);
			Home.renderWidgets(responseDto,false);

			Home.renderWidgetBanner(responseDto,false);
		}else{
			Home.errorRenderer.render();
		}
		ImageOverlayHelper.init();
	}

	private static renderWidgets(response:MagazineHomeResponseDto,isForMobile:boolean){
		var container = null;
		if(Home.columns == null){
			return;
		}
		if(isForMobile){
			container = Home.columns[0]
		}else{
			container =Home.columns[1]
		}
		var widgets = new Array<HomeItemRenderer>();

		if(response.showSchedule && !isForMobile){
			widgets.push(new ScheduleRenderer(container,response.plays,isForMobile));
		}

		if(response.showVideo){
			widgets.push(new VideoRenderer(container, response.videoId, response.videoPreviewImage, isForMobile));
		}

		for(var i = 0; i < widgets.length; i++){
			widgets[i].render();
		}
	}

	private static renderWidgetBanner(response:MagazineHomeResponseDto,isForMobile:boolean){
		var widgets = new Array<HomeItemRenderer>();

		if(response.showFacebook){
			widgets.push(new FacebookRenderer(Home.bannerContainer,isForMobile));
		}

		if(response.showNewsletter){
			widgets.push(new NewsletterRenderer(Home.bannerContainer,isForMobile));
		}

		if(response.showBook){
			widgets.push(new BookRenderer(Home.bannerContainer, response.bookLink, response.bookName,isForMobile));
		}

		for(var i = 0; i < widgets.length; i++){
			widgets[i].render();
		}
	}

}
